import React, { SFC } from 'react';
import DefaultedEditContainer from 'app/components/presentation/containers/DefaultedEditContainer';
import { StackedLabel, SeparableLabel } from 'app/components/presentation/forms/Labels';
import { createStyles } from 'app/utils/css';
import TimezoneForm from 'app/components/forms/Timezone';
import MarginGroup from 'app/components/layout/MarginGroup';
import AllLanguages from 'app/components/forms/AllLanguages';
import { T } from 'app/components/localization';
import { GREY_S } from 'app/constants/Colors';
import { Language } from 'app/constants/enums/Language';
import { Timezone, getTimezoneByName } from 'app/constants/schemas/Timezone';
import { LanguageId } from 'app/constants/enums/Language/data';

interface IProps {
  language: Language;
  setLanguage: (languageId: LanguageId) => void;
  timezone: Timezone;
  setTimezone: (timezone: Timezone) => void;
}

const LanguageAndTimezoneField: SFC<IProps> = ({ language, setLanguage, timezone, setTimezone }) => (
  <T>{(t) =>
    <Styles>{(css) => {
      return (
        <DefaultedEditContainer
          collapsedChildren={
            <>
              <StackedLabel label={t('admin.users.user-form.language')}>
                <span className={css('disabledLabel')}>
                  {language.getName(t)}
                </span>
              </StackedLabel>
              <StackedLabel label={t('admin.users.user-form.timezone')}>
                <span className={css('disabledLabel')}>{timezone.name}</span>
              </StackedLabel>
            </>
          }
          editableChildren={
            <MarginGroup margin="1.5em">
              <SeparableLabel label={t('admin.users.user-form.language')}>{(inputId, labelId, labelRef) =>
                <AllLanguages
                  labelId={labelId}
                  labelRef={labelRef}
                  onChange={setLanguage}
                  value={language.id}
                />
              }</SeparableLabel>
              <TimezoneForm
                label={t('admin.users.user-form.timezone')}
                onChange={(name) => setTimezone(getTimezoneByName(name))}
                value={timezone.name}
              />
            </MarginGroup>
          }
          editBtnAriaLabel={t('admin.users.user-form.edit-language-timezone')}
        />
      );
    }}</Styles>
  }</T>
);

const Styles = createStyles({
  disabledLabel: {
    color: GREY_S,
  },
});

export default LanguageAndTimezoneField;
